// src/context/NavContext.ts
import React from 'react';

export type NavTheme = 'light' | 'dark';

export const NavContext = React.createContext<{
  setHideNav: (hide: boolean) => void;
  navTheme: NavTheme;
  setNavTheme: (theme: NavTheme) => void;
}>({ setHideNav: () => {}, navTheme: 'light', setNavTheme: () => {} });
